import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export interface ActiveCall {
  memberCIDName: string;
  memberCIDNumber: string;
  joinedEpoch: string;
  calledTime: string;
  queueName: string;
  agentName: string;
  memberSessionUUID: string;
  name: string;
  [key: string]: any;
}

interface State {
  items: ActiveCall[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: State = {
  items: [],
  status: 'idle',
  error: null,
};

export const updateActiveCallsCallCenter = createAsyncThunk<ActiveCall[], ActiveCall[] | ActiveCall>(
  'activeCallCenter/update',
  async (calls) => Array.isArray(calls) ? calls : [calls]
);



export const removeActiveCallsCallCenter = createAsyncThunk(
  'activeCallCenter/remove',
  async (sessionUUID: string) => sessionUUID
);

export const removeAllActiveCallCenterData = createAsyncThunk(
  'activeCallCenter/clearAll',
  async () => true
);

const activeCallCenterSlice = createSlice({
  name: 'activeCallCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateActiveCallsCallCenter.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateActiveCallsCallCenter.fulfilled, (state, action) => {
  state.status = 'succeeded';
  const calls = action.payload;

  if (Array.isArray(calls)) {
    calls.forEach((call) => {
      const existingIndex = state.items.findIndex(
        (item) => item.memberSessionUUID === call.memberSessionUUID
      );

      if (existingIndex !== -1) {
        state.items[existingIndex] = call;
      } else {
        state.items.push(call);
      }
    });
  } else {
    console.error("Expected an array of ActiveCall but got:", calls);
  }
})
      .addCase(removeActiveCallsCallCenter.fulfilled, (state, action) => {
        const sessionUUID = action.payload;
        state.items = state.items.filter(
          (item) => item.memberSessionUUID !== sessionUUID
        );
      })
      .addCase(removeAllActiveCallCenterData.fulfilled, (state) => {
        state.items = [];
      });
  },
});

export default activeCallCenterSlice.reducer;
